import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import { styled } from "@mui/material/styles";
import { width } from "@mui/system";
import { StaticDatePicker } from "@mui/x-date-pickers";

export const ColumnContainer = styled("div")(({ theme }) => ({
    fontFamily: theme.fonts.default,
    display: "flex",
    flexDirection: "column"
}));

export const RowContainer = styled("div")(({ theme }) => ({
    fontFamily: theme.fonts.default,
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
}));

export const BorderedDialogContent = styled(DialogContent)(({ theme }) => ({
    fontFamily: theme.fonts.default,
    backgroundColor: theme.colors["neutral.900"],
    color: theme.colors["neutral.50"],
    borderRadius: "16px",
    border: `4px solid ${theme.colors["neutral.900"]}`,
    padding: "24px"
}));

export const DialogCloseIconContainer = styled("div")(({ theme }) => ({
    position: "absolute",
    top: 0,
    right: 0,
    marginTop: "13px",
    marginRight: "13px",
    cursor: "pointer"
}));

interface DeadlineRowProps {
    nobackground?: boolean;
    isweekend?: boolean
}

export const DeadlineRow = styled(RowContainer)<DeadlineRowProps>(({ theme, nobackground, isweekend }) => ({
    color: isweekend ? theme.colors["yellow.300"] : theme.colors["neutral.50"],
    backgroundColor: nobackground ? "transparent" : theme.colors["neutral.950"],
    borderRadius: "8px",
    padding: "8px",
    fontWeight: "600"
}));

export const DeadlineDatePicker = styled(StaticDatePicker)(({ theme }) => ({
    '& .MuiPaper-root': {
        backgroundColor: "transparent",
        color: theme.colors["neutral.50"]
    },
    '& .MuiPickerStaticWrapper-content': {
        backgroundColor: "transparent",
        color: theme.colors["neutral.50"]
    },
    '& .MuiPickersCalendarHeader-switchViewIcon': {
        color: theme.colors["neutral.50"]
    },
    '& .MuiPickersArrowSwitcher-button': {
        color: theme.colors["neutral.50"]
    },
    '& .MuiDayPicker-weekDayLabel': {
        color: theme.colors["neutral.500"]
    },
    '& .MuiPickersDay-root': {
        backgroundColor: "transparent",
        color: theme.colors["neutral.50"],
        "&:hover" : {
            backgroundColor: theme.colors["neutral.700"],
        },
        "&.max-date" : {
            border: "1px solid",
            borderColor: theme.colors["neutral.50"]
        },
        "&.Mui-selected" : {
            backgroundColor: theme.colors["lime.500"],
            color: theme.colors["neutral.950"]
        },
        "&.Mui-disabled" : {
            color: theme.colors["neutral.700"]
        }
    },
}));


export const AllocationDeadlinesAccordion = styled(Accordion, {
    shouldForwardProp: (prop) => prop !== 'isHighlighted',
  })<{ isHighlighted?: boolean }>(({ theme, isHighlighted }) => ({
    boxShadow: "none",
    backgroundColor: isHighlighted
      ? theme.colors["yellow.400"]
      : theme.colors["neutral.900"],
    color: isHighlighted
      ? theme.colors["neutral.950"]
      : theme.colors["neutral.50"],
    fontFamily: theme.fonts.default,
    margin: "0 !important",
    width: "100%",
    "& .MuiButtonBase-root": {
      minHeight: "initial !important",
    },
    "& .MuiAccordionSummary-content": {
      margin: "0",
      justifyContent: "space-between",
    },
    "& .MuiAccordionSummary-content.Mui-expanded": {
      margin: "0",
      minHeight: "initial !important",
    },
    "&.Mui-expanded": {
      minHeight: "initial !important",
    },
  }));
  
  export const AllocationDeadlinesAccordionSummary = styled(AccordionSummary, {
    shouldForwardProp: (prop) => prop !== 'isHighlighted',
  })<{ isHighlighted?: boolean }>(({ theme, isHighlighted }) => ({
    display: "flex",
    fontFamily: theme.fonts.default,
    fontSize: theme.fontSizes.sm,
    fontWeight: theme.fontWeights.regular,
    padding: `0`,
    margin: "0",
    minHeight: "4.125rem",
    width: "fit-content",
  
    "& .MuiAccordionSummary-content": {
        gap: "16px", 
        justifyContent: "flex-start",
        alignItems: "center", 
    },
    "& .MuiAccordionSummary-expandIconWrapper": {
        color: isHighlighted
            ? theme.colors["neutral.950"]
            : theme.colors["neutral.50"],
    },
  }));
  
  export const AllocationDeadlinesAccordionDetails = styled(AccordionDetails)(
    ({ theme }) => ({
      backgroundColor: theme.colors["neutral.900"],
      display: "flex",
      flexDirection: "column",
      padding: 0,
      gap: "1rem",
      paddingTop: "1rem"
    })
  );